import { render, staticRenderFns } from "./FormInputCorn.vue?vue&type=template&id=43883b8a&scoped=true&"
import script from "./FormInputCorn.vue?vue&type=script&lang=js&"
export * from "./FormInputCorn.vue?vue&type=script&lang=js&"
import style0 from "./FormInputCorn.vue?vue&type=style&index=0&id=43883b8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43883b8a",
  null
  
)

export default component.exports